import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";

export const useDecryptCard = () => {
  const { bookingId } = useParams(); // Retrieve the bookingId from the URL
  const location = useLocation(); // Retrieve the state passed from the previous screen
  const password = location.state?.password || ""; // Password passed from the previous screen
  const [cardDetails, setCardDetails] = useState(null); // State to hold the decrypted card details
  const [bookingInfo, setBookingInfo] = useState({}); // State to hold booking info

  useEffect(() => {
    const handleDecrypt = async () => {
      try {
        // Resolve tenant ID dynamically and provide a fallback for localhost
        let tenantId = window.location.hostname.split(".")[0];
        if (tenantId === "localhost") {
          tenantId = "defaultTenant"; // Fallback to 'defaultTenant' for localhost
        }

        const response = await axios.get(
          `http://localhost:5001/api/bookings/decryptcard`,
          {
            headers: {
              "X-Tenant-ID": tenantId, // Dynamic tenant ID with localhost fallback
            },
            params: {
              bookingId,
              password, // Pass the password with the request
            },
          }
        );

        setCardDetails(response.data.cardDetails); // Store the decrypted card details
        setBookingInfo({
          bookingId: response.data.bookingId, // Store bookingId
          totalamount: response.data.totalamount, // Store totalamount
        });
      } catch (error) {
        console.error("Error during decryption:", error);
        Swal.fire(
          "Error",
          "Failed to retrieve card details. Please check the booking ID or password.",
          "error"
        );
      }
    };

    if (password) {
      handleDecrypt();
    }
  }, [bookingId, password]); // Include bookingId and password as dependencies

  return {
    cardDetails,
    bookingInfo,
  };
};
